module.exports = __webpack_public_path__ + "static/media/envelope_code.ead515f0.png";